import { render, staticRenderFns } from "./AddFalsePositiveZabbixEvent.vue?vue&type=template&id=38bd0ac2&"
import script from "./AddFalsePositiveZabbixEvent.vue?vue&type=script&lang=js&"
export * from "./AddFalsePositiveZabbixEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports